import { render, staticRenderFns } from "./EmailTemplateDetail.vue?vue&type=template&id=8a24990c"
import script from "./EmailTemplateDetail.vue?vue&type=script&lang=js"
export * from "./EmailTemplateDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports